import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import '../../oe-combo/dropdown-list-category.js';

class DropdownLanding extends PolymerElement {

    static get template() {
        return html
            `
        <style>
            .error {
                padding: 10px 8px;
                display: inline-flex;
            }
            dropdown-list-category {
                
                border-radius: 4px;
                cursor: pointer;
                width: var(--dropdownwidth, 278px);
                height: var(--dropdownheight, 50px);
                
                --paper-input-container-underline: {
                    display: none;
                    height: 0px;
                }
                --paper-input-container-underline-focus: {
                    display: none
                }
                --paper-input-container-underline-disabled: {
                    display: none
                }
                --paper-input-container-color: {
                    border: none;
                }
                --paper-input-container : {
                    padding: 0 0;
                }
                --paper-item:{
                    color:#101214 !important;
                }
            }

            dropdown-list-category:hover{
                background: #0A2938 !important;
                border:1px solid #0A2938 !important; 
            }

            .dropdown-disable{
                opacity: 0.25 !important;
                pointer-events: none;
            }

            @media (min-width:320px) and (max-width:812px) {
                dropdown-list-category{
                    width: 97%;
                }
            }
            .menuheight{
                --menuheight : auto;
            }
    
        </style>
            <div class="">
            
                <div style="padding: 10px;">
                <dropdown-list-category class="othermethod-security-toggle menuheight"  
					on-change="_onItemSelectWorkFlow"
					show-filtered-only  
					error-message="Please enter a valid value" 
					value="{{dropdownlist[0]}}"
					valueproperty="id" listdata="{{dropdownlist}}"  
					placeholder={{placeHolderName}} displayproperty="defaultlabel" borderright = {{borderright}} fontcolor = {{fontcolor}} icon-color = {{iconColor}}
                    style="background: {{dropdownBckColor}}; border: 1px solid {{dropdownBordColor}}" new-height = {{newHeight}}
					>
				</dropdown-list-category>
                </div>
               <!-- 
                <div style="padding: 10px;">
                <dropdown-list-category class$="othermethod-security-toggle {{_ifdropdownisDisabled(disabledProp)}}"  
					on-change="_onItemSelectWorkFlow"
					show-filtered-only  
					error-message="Please enter a valid value" 
					value="{{dropDownList[0]}}"
					valueproperty="id" listdata="{{dropDownList}}"  
					placeholder="Make a payment" displayproperty="defaultlabel" borderright = {{borderright}} fontcolor = {{fontcolor}} icon-color = {{iconColor}}
                    style="background: {{dropdownBckColor}}; border: 1px solid {{dropdownBckColor}}"
					>
				</dropdown-list-category>
                </div>
            -->
        </div>
        `
    }

    static get properties() {
        return {
            disabledProp: {
                type: Boolean,
                value: true
            },
            dropdownBckColor: {
                type: String,
                value: "#003D4C"
            },
            dropdownlist: {
                type: Array,
                notify: true
            },
            placeHolderName: {
                type: String,
                notify: true
            },
            newHeight: {
                type: String,
                notify: true
            },
            dropdownBordColor: {
                type: String,
                value: "#003D4C"
            },
            fontcolor: {
                type: String,
                notify: true
            },
            borderright: {
                type: String,
                notify: true
            },
            iconColor: {
                type: String,
                notify: true
            },
            selectedValue: {
                type: String,
                notify: true
            }
        };
    }

    constructor() {
        super();

    }

    ready() {
        super.ready();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    _onItemSelectWorkFlow(event) {
        this.selectedValue = event.target.value;

        /*if (event.target.value == 'Within NBB')
            window.oe_navigate_to("/payments-within-transfer");
        else
            window.oe_navigate_to("/"); */
    }

    _ifdropdownisDisabled(disabled) {
        return disabled ? "dropdown-disable" : "";
    }



}

customElements.define('dropdown-landing', DropdownLanding);